import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { CustomValidators } from '@narik/custom-validators';
import { NgIf } from '@angular/common';
import { RxInputModule } from '@roomex/rx-components';
import { FormUtils } from '@rx-applications/shared/utils-forms';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'rx-password-match-form',
  templateUrl: './password-match-form.component.html',
  standalone: true,
  imports: [ReactiveFormsModule, RxInputModule, NgIf],
})
export class PasswordMatchFormComponent extends FormUtils implements OnInit {
  @Input() parentForm: UntypedFormGroup;
  @Input() passwordLabel: string;
  @Input() passwordConfirmLabel: string;
  @Input() passwordMissing: string;
  @Input() passwordNotEqual: string;
  @Input() passwordPattern: string;

  // convenience getter for easy access to form fields
  get f(): { [key: string]: AbstractControl } {
    return this.parentForm.controls;
  }

  ngOnInit() {
    this.parentForm.addControl(
      'password',
      new UntypedFormControl('', [
        Validators.required,
        Validators.pattern(/^(?=.*\d)(?=.*[-^$*.!@#%&/\\,><':;|_~`=+[\]{}()?"])(?=.*[a-z])(?=.*[A-Z])(?!.*\s).{8,}$/),
      ])
    );

    this.parentForm.addControl(
      'reTypePassword',
      new UntypedFormControl('', [Validators.required, CustomValidators.equalTo(this.parentForm.controls['password'])])
    );
  }
}
